module.exports = __webpack_public_path__ + "img/salon24_visuel sans logo.b4a3f46f.jpg";